/* eslint-disable callback-return */

(function () {

  var waitTimeMs = 115;
  var maxWaitTries = 20;
  var trfq = null;

  function onTrfqReady(next, tries) {
    if (typeof window._trfq === 'object') {
      trfq = window._trfq;
      next();
    } else {
      if (typeof tries === 'undefined') {
        tries = 0;
      }
      setTimeout(function () {
        if (typeof window._trfq === 'undefined') {
          if (tries <= maxWaitTries) {
            onTrfqReady(next, ++tries);
          } else {
            next(new Error('trfq timeout'));
          }
        } else {
          trfq = window._trfq;
          next();
        }
      }, waitTimeMs);
    }
  }

  function doClick(eid, params) {
    if (!trfq || !eid) { return; }
    trfq.push(['cmdLogPageEvent', 'click', eid, params]);
  }

  function doImpression(eid) {
    if (!trfq || !eid) { return; }
    trfq.push(['cmdLogImpression', eid]);
  }

  function doCustom(customEvent, eid, params) {
    if (!trfq || !customEvent || !eid) { return; }
    trfq.push(['cmdLogPageEvent', customEvent, eid, params]);
  }

  var traffic = {

    click: function (eid, params) {
      onTrfqReady(function (err) {
        if (!err) {
          doClick(eid, params);
        } else {
          console.log(err);
        }
      });
      return this;
    },

    impression: function (eid) {
      onTrfqReady(function (err) {
        if (!err) {
          doImpression(eid);
        } else {
          console.log(err);
        }
      });
      return this;
    },

    custom: function (customEvent, eid, params) {
      onTrfqReady(function (err) {
        if (!err) {
          doCustom(customEvent, eid, params);
        } else {
          console.log(err);
        }
      });
      return this;
    }
  };

  ux.traffic = ux.traffic || traffic;
  ux.traffic.click = ux.traffic.click || traffic.click;
  ux.traffic.impression = ux.traffic.impression || traffic.impression;
  ux.traffic.custom = ux.traffic.custom || traffic.custom;

  if (window !== window.top) {
    var plId = typeof requestContext !== 'undefined' ? requestContext.plId : 1;
    ux.traffic.custom('inapp', 'mcx.help.inapp',
      [
        ['url', document.referrer],
        ['plId', plId]
      ]);
  }

}());
